import { render } from "./index.vue?vue&type=template&id=1ba2534a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1ba2534a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ba2534a"

export default script